import { memo, useCallback } from "react";

import { Box, Center } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Button, Text, Title } from "components";
import { AuthorityConstants } from "constant";
import { CreditService } from "services";
import { CreditOptionsResponse, CreditResponse, UserResponse } from "types";
import { UserUtils } from "utils";

import CreditHeader from "./header";
import CreditTabs from "./tabs";

const { ROLE_CR_C } = AuthorityConstants;

interface ClientCreditProps {
  credit?: CreditResponse;
  options?: CreditOptionsResponse;
  user: UserResponse;
}

const ClientCreditComponent = ({ credit, options, user }: ClientCreditProps) => {
  const { t } = useTranslation();

  const createNewCredit = useCallback(() => {
    CreditService.creditsNew(user.id);
  }, [user]);

  if (!credit || !options) {
    return (
      <Box>
        {UserUtils.hasAuthority(ROLE_CR_C) && (
          <Button onClick={createNewCredit} mx={"sm"}>
            {t("credit.new.title")}
          </Button>
        )}
        <Center>
          <Box my={64} w={450}>
            <Title order={4} ta={"center"}>
              {t("credit.view.empty.title")}
            </Title>
            <Text ta={"center"}>{t("credit.view.empty.description")}</Text>
          </Box>
        </Center>
      </Box>
    );
  }

  return (
    <Box>
      <CreditHeader credit={credit} />
      <CreditTabs credit={credit} options={options} />
    </Box>
  );
};

const ClientCredit = memo(ClientCreditComponent);

export default ClientCredit;
